export default __webpack_public_path__ + "static/media/category-phones.9d91280e.png";